import * as React from 'react';
import Icon from '@mui/material/Icon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import BasicMenu from '../../../../../components/BasicMenu';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import {
  refreshServiceMonitorSummary,
  selectLastUpdatedServiceStatus,
} from '../../../../../slices/utils/utilsSlice';
import { getTimeDiff } from '../../../../../components/Notifications/utils';

export default function ServiceStatusSettings() {
  const lastUpdated = useAppSelector(selectLastUpdatedServiceStatus);
  const dispatch = useAppDispatch();
  return (
    <BasicMenu direction="vert">
      <ListItemButton onClick={() => dispatch(refreshServiceMonitorSummary(true))}>
        <ListItemIcon>
          <Icon>refresh</Icon>
        </ListItemIcon>
        <ListItemText
          primary="Refresh data"
          secondary={lastUpdated && `Last updated: ${getTimeDiff(lastUpdated.toString())}`}
        />
      </ListItemButton>
    </BasicMenu>
  );
}
